import { Search } from "@/assets/icons";
import {
  SearchFieldType,
  SearchFieldVariant,
} from "@/pages/inbox/components/search-field";
import clsx from "clsx";
import { useRef } from "react";
import styles from "./styles.scss";

export const UserSearch = ({
  searchValue,
  onSearch,
  placeholder,
}: {
  searchValue: string;
  onSearch: (value: string) => void;
  placeholder?: string;
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div
      className={clsx(
        styles.container,
        styles[SearchFieldType.Gray],
        styles[SearchFieldVariant.Large],
      )}
    >
      <Search className={clsx(styles.searchIcon, styles.clickable)} />
      <input
        ref={inputRef}
        type="text"
        value={searchValue}
        placeholder={
          placeholder ?? "Search for Name, Emirates ID, or Passport #"
        }
        className={styles.textInput}
        onChange={e => {
          onSearch(e.target.value);
        }}
      />
    </div>
  );
};
